import { render, staticRenderFns } from "./ProductContentPage.vue?vue&type=template&id=00c929b2&scoped=true&"
import script from "./ProductContentPage.vue?vue&type=script&lang=js&"
export * from "./ProductContentPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentPage.vue?vue&type=style&index=0&id=00c929b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c929b2",
  null
  
)

export default component.exports